module.exports = "/packs/015-2f297f4adebfb670b8c63c4c787dcdb5.jpg";